import { StoryblokLink } from '@/components/shared/storyblok-link'
import { Button } from '@/components/ui/button'
import { NavigationMenuLink } from '@/components/ui/navigation-menu'
import type { GlobalNavSubMenuCaseStudyStoryblok } from '@/lib/types/component-types-sb'
import { ChevronRight } from 'lucide-react'
import { NavSubMenuCaseStudy } from './nav-sub-menu-case-study'

export function NavSubMenuColCaseStudy({ col }: { col: GlobalNavSubMenuCaseStudyStoryblok }) {
  return (
    <NavigationMenuLink
      asChild
      key={col._uid}
    >
      <div className="space-y-2">
        <div className="flex items-center justify-between px-2.5">
          <span className="text-muted-foreground text-sm font-medium">User Story</span>
          <Button
            variant="link-brand"
            size="sm"
            asChild
            className="gap-0 px-0"
          >
            <StoryblokLink
              prefetch={true}
              link={{
                linktype: 'story',
                cached_url: 'blog',
              }}
            >
              Read more <ChevronRight className="text-brand" />
            </StoryblokLink>
          </Button>
        </div>
        <NavSubMenuCaseStudy col={col} />
      </div>
    </NavigationMenuLink>
  )
}
